export default __webpack_public_path__ + "static/media/courses.bc3f15c9.svg";